export default __webpack_public_path__ + "static/assets/1ccfcb5fd3c161ec6e44bc1312a5e577.png";